import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  IconButton,
  Tooltip,
  Chip,
  Divider,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import MathInputField from "../MathInputField/MathInputField";
import "./CustomInputField.css";
import "katex/dist/katex.min.css"; // Import KaTeX styles
import { BlockMath } from "react-katex"; // Import KaTeX component
import MathPreview from "../MathPreview/MathPreview";

const CustomInputField = ({ body, onBodyChange, label, isbigger }) => {
  const [fields, setFields] = useState([{ type: "text", value: "" }]);

  // Handle input change
  const handleInputChange = (index, value) => {
    const updatedFields = [...fields];
    updatedFields[index].value = value;
    setFields(updatedFields);
    updateConcatenatedValue(updatedFields);
  };

  // Add a new field
  const addField = (type) => {
    setFields([...fields, { type, value: "" }]);
  };

  // Remove a field
  const removeField = (index) => {
    const updatedFields = fields.filter((_, i) => i !== index);
    setFields(updatedFields);
    updateConcatenatedValue(updatedFields);
  };

  // Concatenate field values and update parent component
  const updateConcatenatedValue = (updatedFields) => {
    const concatenated = updatedFields
      .map((field) => (field.type === "math" ? `$$${field.value}$$` : field.value))
      .join(" ");
    onBodyChange(concatenated);
  };

  return (
    <Box className="custom-input-field">
      {/* Field List */}
      <Typography className="label">{label}</Typography>
      <Box className="fields-wrapper">
        {fields.map((field, index) => (
          <Box key={index} className="field-container">
            {field.type === "text" ? (
              <TextField
                className="text-input"
                value={field.value}
                onChange={(e) => handleInputChange(index, e.target.value)}
                placeholder="Text..."
                fullWidth
                rows={isbigger ? 3 : 1}
                multiline={isbigger}
              />
            ) : (
              <MathInputField
                value={field.value}
                onChange={(value) => handleInputChange(index, value)}
                editable
                placeholder="Math..."
              />
            )}
            <Tooltip title="Remove Field">
              <IconButton onClick={() => removeField(index)} color="error">
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        ))}
      </Box>

      {/* Action Buttons */}
      <Box className="actions">
        <Tooltip title="Add Text Field">
          <Chip
            icon={<AddIcon />}
            label="Text"
            color="primary"
            onClick={() => addField("text")}
            clickable
          />
        </Tooltip>
        <Tooltip title="Add Math Field">
          <Chip
            icon={<AddIcon />}
            label="Math"
            color="secondary"
            onClick={() => addField("math")}
            clickable
          />
        </Tooltip>
      </Box>

      {/* Preview Section */}
      <Divider className="divider" />
      <Box className="preview-section">
        <Typography variant="h6">Preview:</Typography>
        <Box className="latex-preview">
          {/* <BlockMath>{body}</BlockMath> */}
          <MathPreview text={body} />
        </Box>
      </Box>
    </Box>
  );
};

export default CustomInputField;
